module.exports = __webpack_public_path__ + "media/static/logos/outside-logo--white-81956a113b4c5e270d777b6992a7bfe5.svg";